import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { usePageTitle } from '@/shared/usePageTitle';
import { PageHeader } from '@/shared/PageHeader';
import { CreateSelectiveModal, ActiveSelectivesModal } from './SelectivesModals';

/**
 * Pagina /selectives — accessibile via URL diretto.
 * Nella nuova UI il flusso primario passa dai due bottoni della dashboard
 * (+SELETTIVA / Selettive Attive) che aprono direttamente i popup.
 * Questa pagina espone gli stessi popup tramite due bottoni evidenti, per
 * compatibilita' con bookmark o per chi navighi direttamente all'URL.
 */
export function SelectivesPage(): React.JSX.Element {
  usePageTitle('Selettive');
  const [searchParams, setSearchParams] = useSearchParams();
  const [showCreate, setShowCreate] = useState(searchParams.get('new') === '1');
  const [showActive, setShowActive] = useState(false);

  useEffect(() => {
    if (searchParams.get('new') === '1') {
      setShowCreate(true);
      const next = new URLSearchParams(searchParams);
      next.delete('new');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="page-container">
      <PageHeader title="🚨 Selettive" />

      <div className="quick-actions">
        <button className="quick-action danger" onClick={() => setShowCreate(true)}>
          <span className="quick-action-icon">🚨</span>
          <span className="quick-action-label">+SELETTIVA</span>
        </button>
        <button className="quick-action danger-light" onClick={() => setShowActive(true)}>
          <span className="quick-action-icon">📋</span>
          <span className="quick-action-label">Selettive Attive</span>
        </button>
      </div>

      {showCreate && <CreateSelectiveModal onClose={() => setShowCreate(false)} />}
      {showActive && <ActiveSelectivesModal onClose={() => setShowActive(false)} />}
    </div>
  );
}
